<div class="document-modal" [class.active]="active">
    <div class="document-modal-background">
        <div class="document-modal-container" *ngIf="!loading"
            [innerHTML]="preview">
        </div>
        <div class="document-modal-container" *ngIf="loading"
            style="display: flex; justify-content: center; align-items: center;">
            <div class="document-visualizer-modal__loading">Carregando documento...
            </div>
        </div>
    </div>

    <button class="document-modal-close" (click)="close()">
        <svg-icon src="assets/images/icon-times.svg"
            aria-hidden="true"></svg-icon>
    </button>
</div>